import { delete_0 } from 'owa-locstrings/lib/strings/delete_0.locstring.json';
import { deleteEventConfirmationSubText } from 'owa-locstrings/lib/strings/deleteeventconfirmationsubtext.locstring.json';
import { deleteEventConfirmationTitleText } from 'owa-locstrings/lib/strings/deleteeventconfirmationtitletext.locstring.json';
import loc from 'owa-localize';
import type { ClientItemId } from 'owa-client-ids';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { respondToCalendarEvent } from 'owa-calendar-events-actions';
import type { ViewType } from 'owa-calendar-actions';
import type ResponseTypeType from 'owa-service/lib/contract/ResponseTypeType';
import { shouldShowDeclinedEvents } from 'owa-show-declined-meetings-user-config';
import type EventScope from 'owa-service/lib/contract/EventScope';
import { isRemoveDeleteConfirmationDialogFlightEnabled } from './shouldHideConfirmationDialog';

/**
 * Open the decline modal
 */
export default async function declineCalendarEventWithConfirm(
    itemId: ClientItemId,
    currentResponseType: ResponseTypeType,
    eventScope: EventScope,
    actionSource: ViewType,
    onCancel?: () => void,
    onConfirm?: () => void
) {
    let title = loc(deleteEventConfirmationTitleText);
    let confirmation = loc(deleteEventConfirmationSubText);

    if (
        isRemoveDeleteConfirmationDialogFlightEnabled() ||
        (await confirm(title, confirmation, false, {
            okText: loc(delete_0),
            delayCallbackAfterAnimation: true,
        })) === DialogResponse.ok
    ) {
        respondToCalendarEvent(
            itemId,
            currentResponseType,
            'Decline',
            'NoData' /* current FreeBusy type is not needed for decline response */,
            eventScope,
            false /* sendResponse */,
            actionSource,
            null /* notes */,
            undefined /* proposeNewTime */,
            shouldShowDeclinedEvents() /* showDeclinedEvents */
        );
        if (onConfirm) {
            onConfirm();
        }
    } else {
        if (onCancel) {
            onCancel();
        }
    }
}
